import type { ConceptDef } from '../types';

export const matchShapes: ConceptDef = {
  kind: 'tileMatch',
  id: 'match-shapes',
  label: 'Match Shapes',
  category: 'Matching',
  description: 'See a shape; tap the same shape among labeled tiles.',
  config: {
    promptMode: 'TEXT',
    tileCount: 4,
    items: [
      { say: '⭕', answer: '⭕ circle' },
      { say: '◼', answer: '◼ square' },
      { say: '▲', answer: '▲ triangle' },
      { say: '★', answer: '★ star' },
      { say: '❤', answer: '❤ heart' },
      { say: '◆', answer: '◆ diamond' },
    ],
  },
};
